"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processUpdateOrderLine = void 0;
const helpers_1 = require("../../helpers");
const sendEmail_1 = require("../sendEmail");
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderById_1 = require("./getOrderById");
const getOrderLineById_1 = require("./getOrderLineById");
const updateOrderLineVersion_1 = require("./updateOrderLineVersion");
const processUpdateOrderLine = async (supabase, order_line_id, action, order_line_config) => {
    const order_line = await (0, getOrderLineById_1.getOrderLineById)(supabase, order_line_id);
    const order = await (0, getOrderById_1.getOrderById)(supabase, order_line.order_id);
    if (!order_line.versions)
        throw new Error("No versions found");
    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(order_line.versions);
    if (!latest_version)
        throw new Error("No latest version found");
    switch (action) {
        case helpers_1.OrderLineAction.UPDATE_TRANSFER_LINE_CONFIG: {
            (0, updateOrderLineVersion_1.updateOrderLineVersion)(supabase, {
                ...latest_version,
                config: order_line_config,
            });
            break;
        }
        case helpers_1.OrderLineAction.ALTERNATE_TEE_TIME_ACCEPTED: {
            (0, updateOrderLineVersion_1.updateOrderLineVersion)(supabase, {
                ...latest_version,
                status: helpers_1.OrderLineStatus.CONFIRMED,
            });
            // send email to the supplier informing them it has been confirmed.
            const tee_times_accepted_email_obj = {
                language_code: "en",
                template_id: helpers_1.EMAIL_GOLF_LINE_ALTERNATIVE_ACCEPTED,
                order_id: order.id,
                order_line_id: order_line.id,
            };
            await (0, sendEmail_1.sendEmail)(tee_times_accepted_email_obj);
            break;
        }
        case helpers_1.OrderLineAction.ALTERNATE_TEE_TIME_REJECTED: {
            // if the alternate order line is rejected then we need to cancel the order line and send an email to the supplier informing them of the cancellation.
            (0, updateOrderLineVersion_1.updateOrderLineVersion)(supabase, {
                ...latest_version,
                status: helpers_1.OrderLineStatus.CANCELLED_REJECTED,
            });
            // send email to the supplier informing them it has been confirmed.
            const tee_times_rejected_email_obj = {
                language_code: "en",
                template_id: helpers_1.EMAIL_GOLF_LINE_ALTERNATIVE_REJECTED,
                order_id: order.id,
                order_line_id: order_line.id,
            };
            await (0, sendEmail_1.sendEmail)(tee_times_rejected_email_obj);
            break;
        }
    }
};
exports.processUpdateOrderLine = processUpdateOrderLine;
